// MyWallet.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
// import MainLayout from '../../layouts/MainLayout';
import './MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faWallet } from '@fortawesome/free-solid-svg-icons';

const MyWallet = () => {
  const authState = useSelector(state => state.authReducer);
  const userId = authState.user._id
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
  const [walletBalancePoints, setWalletBalancePoints] = useState(0);
  const [walletLastUpdated, setWalletLastUpdated] = useState();
  const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');

  const [walletData, setWalletData] = useState([]);
  const [selectedWalletId, setSelectedWalletId] = useState([]);

  //WalletBalance
  const fetchWalletBalance = useCallback(() => {
    const config = {
      url: "/walletbalance",
      method: "get",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response:", response);
        if (response) {
          // console.log("Response in array:", response);
        //   setWalletBalanceAmount(response.balanceAmount);
          setWalletBalanceAmount(
            Number(response?.balanceAmount?.$numberDecimal ?? response?.balanceAmount ?? 0)
          );
          setWalletBalancePoints(response.balancePoints);
          setWalletLastUpdated(response.lastTransactionDate);
          setWalletLastUpdatedRemarks(response.remarks);
        } else {
          console.error("Invalid response format: Wallet not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching wallet master:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWalletBalance();
  }, [authState.isLoggedIn, fetchWalletBalance]);

  //Wallet Transactions
  const fetchWallet = useCallback(() => {
    const config = {
      url: "/wallet",
      method: "get",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response:", response);
        if (response && Array.isArray(response)) {
          setWalletData(response);
        } else {
          console.error("Invalid response format: Wallet transaction data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching wallets:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWallet();
  }, [authState.isLoggedIn, fetchWallet]);

  const sortedWalletData = [...walletData].sort((a, b) => new Date(b.dateTransaction) - new Date(a.dateTransaction));

  const handleWalletView = (_id) => {
    setSelectedWalletId(prevId => (prevId === _id ? null : _id));
  };

  const handleTopupClick = (userId) => {
    navigate('/wallet-topup', { state: { userId: userId } });
  };

  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleCancel = () => {
    navigate(-1);
  };

    return (
        <div className="bg-gradient-to-b from-black via-gray-950 to-black text-white min-h-[100vh]">
            <div className="p-2 space-y-1">
                <div className="flex flex-col lg:flex-row lg:justify-between gap-1">
                    <div>
                        <h3 className="text-sm lg:text-lg font-semibold flex flex-wrap items-center gap-2 text-cyan-300">
                            <FontAwesomeIcon icon={faWallet} className="text-pink-500 text-xl" />
                            <span className="whitespace-nowrap">
                                Think5Whys FuelStash Credits / Transfers 
                            </span>
                        </h3>
                    </div>
                    <div className="flex flex-row gap-2">
                        <button
                        disabled
                            className="whitespace-nowrap bg-gradient-to-r from-fuchsia-600 to-purple-700 text-xs lg:text-xs px-1 py-1 rounded-lg transition"
                            onClick={() => handleTopupClick(userId)}
                        >
                            ⚡ Recharge
                        </button>
                        <button
                            className="bg-white/10 hover:bg-white/20 text-xs lg:text-xs px-1 py-1 rounded-lg transition border border-white/10"
                            onClick={handleCancel}
                        >
                            ⬅️ Back
                        </button>
                    </div>
                </div>

                <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-md">
                    <div className="absolute inset-0 opacity-20 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 blur-2xl"></div>
                    <div className="relative flex justify-between items-center">
                        <div>
                            <p className="text-xs lg:text-sm text-gray-200">Available Balance</p>
                            <p className="text-sm lg:text-lg font-bold text-cyan-300 mt-1">
                                {Number(walletBalanceAmount || 0).toFixed(2)}
                            </p>
                        </div>
                        <div className="text-xs lg:text-sm text-gray-200 text-right">
                            FuelStash Wallet ⚡
                        </div>
                    </div>
                </div>

                {/* CONTENT */}
                {loading ? (
                    <Loader />
                ) : walletData?.length === 0 ? (
                    <div className="flex items-center justify-center text-gray-200 text-sm h-64 bg-white/5 rounded-xl border border-white/10">
                        No transactions yet ⚡
                    </div>
                ) : (
                    <div className="space-y-3">

                        {sortedWalletData.map((walletItem, index) => {

                            const amount = Number(walletItem?.amount?.$numberDecimal ?? walletItem?.amount ?? 0);
                            const isCredit = walletItem.inOut === 1;

                            return (
                                <div
                                    key={walletItem._id}
                                    className="relative bg-white/5 border border-white/10 hover:border-cyan-500/30 transition rounded-xl p-4 backdrop-blur-md"
                                >

                                    {/* LEFT ACCENT */}
                                    <div className={`absolute left-0 top-0 h-full w-1 rounded-l-xl ${isCredit ? "bg-green-400" : "bg-red-400"}`}></div>

                                    <div className="flex justify-between items-start pl-3">

                                        <div className="text-sm space-y-1">

                                            <div className="text-gray-100">
                                                <span className="text-gray-200">{index + 1}.</span>{" "}
                                                {formatDateTime(walletItem.dateTransaction)}
                                            </div>

                                            <div className="flex items-center gap-2">
                                                <span className="text-gray-200 text-xs">
                                                    {walletItem.currency}
                                                </span>
                                                <span className={`font-semibold ${isCredit ? "text-green-400" : "text-red-400"}`}>
                                                    {isCredit ? "+" : "-"}{amount.toFixed(2)}
                                                </span>

                                                <span className={`text-[10px] px-2 py-0.5 rounded-full ${
                                                    isCredit
                                                        ? "bg-green-500/10 text-green-300"
                                                        : "bg-red-500/10 text-red-300"
                                                }`}>
                                                    {isCredit ? "CREDIT" : "DEBIT"}
                                                </span>
                                            </div>
                                        </div>

                                        <Tooltip text="View details" position="top">
                                            <button
                                                className="w-10 px-1 py-1 text-gray-200 hover:text-white transition"
                                                onClick={() => handleWalletView(walletItem._id)}
                                            >
                                                <i className="fa-solid fa-eye"></i>
                                            </button>
                                        </Tooltip>
                                    </div>
                                    {selectedWalletId === walletItem._id && (
                                        <div className="mt-1 bg-black/40 border border-white/10 rounded-xl p-1 text-xs space-y-1 text-gray-100">
                                            <p className="text-cyan-100 text-xs lg:text-sm"><span className="text-gray-200">Particulars:</span> {walletItem.particulars}</p>
                                            <p className="text-cyan-100 text-xs lg:text-sm"><span className="text-gray-200">Remarks:</span> {walletItem.remarks}</p>
                                            <p className="text-cyan-100 text-xs lg:text-sm"><span className="text-gray-200">Mode:</span> {walletItem.modePayment}</p>
                                            <p className="text-cyan-100 text-xs lg:text-sm"><span className="text-gray-200">Txn ID:</span> {walletItem.transactionId}</p>
                                            <p className="text-cyan-100 text-xs lg:text-sm"><span className="text-gray-200">Payment:</span> {walletItem.paymentDetails}</p>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <div className="rounded-xl border border-gray-800 bg-gray-900 p-3 text-center">
                <div className="text-[11px] text-gray-400">
                    ⚡ Think5Whys FuelStash • Simple. Fast. Transparent. Global.
                </div>
            </div>
        </div>
    );
};

export default MyWallet;